/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, leftValue: NonNullable<unknown>, leftMetric: NonNullable<unknown>, rightChain: NonNullable<unknown> }} Chain_Page_Compare_Validators_Or_Miners_Different_No_RightInputs */



/**
* | output |
* | --- |
* | "{leftChain} has {leftValue} {leftMetric}, while {rightChain} has no data" |
*
* @param {Chain_Page_Compare_Validators_Or_Miners_Different_No_RightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_validators_or_miners_different_no_right = /** @type {((inputs: Chain_Page_Compare_Validators_Or_Miners_Different_No_RightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Validators_Or_Miners_Different_No_RightInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} has ${i?.leftValue} ${i?.leftMetric}, while ${i?.rightChain} has no data`)
});